// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".time-worked-page[data-v-bba23866] {\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.time-filter-wrap[data-v-bba23866] {\n  position: sticky;\n  z-index: 3;\n  top: 0;\n  padding: 16px 16px 0;\n  background: var(--portal-canvas);\n}\n.time-worked-content[data-v-bba23866] {\n  min-height: 0;\n  flex: 1;\n}\n@media (max-width: 599px) {\n.time-filter-wrap[data-v-bba23866] {\n    padding: 12px 12px 0;\n}\n}", ""]);
// Exports
module.exports = exports;
